routes.$inject = ['$stateProvider'];

var templateLoginUrl = require('./templates/login.html');
var templatePasswordUrl = require('./templates/password.html');
var templatePinUrl = require('./templates/pin.html');
var templateRegistrationUrl = require('./templates/registration.html');
var templateVerificationUrl = require('./templates/verification.html');
var templateForgottenUrl = require('./templates/forgotten.html');
var templateTokenUpdated = require('./templates/token_updated.html');

export default function routes($stateProvider) {
    $stateProvider
        .state('app.login', {
            url: '/login',
            templateUrl : templateLoginUrl,
            controller: 'LoginController',
            controllerAs: 'loginCtrl',
            params : {
               bodyClasses : 'auth'
            }
        })
        .state('app.password', {
            url: '/password',
            templateUrl : templatePasswordUrl,
            controller: 'LoginController',
            controllerAs: 'loginCtrl',
            params : {
               bodyClasses : 'auth'
            }
        })
        .state('app.pin', {
            url: '/pin',
            templateUrl : templatePinUrl,
            controller: 'LoginController',
            controllerAs: 'loginCtrl',
            params : {
               bodyClasses : 'auth'
            }
        })
        .state('app.registration', {
            url: '/register',
            templateUrl: templateRegistrationUrl,
            controller: 'RegistrationController',
            controllerAs: 'registrationCtrl',
            params : {
               bodyClasses : 'auth',
               code: {
                    value: 'null',
                    squash: true
               }
            }
        })
        .state('app.verify', {
            url: '/verify/:code',
            templateUrl: templateVerificationUrl,
            controller: 'VerificationController',
            controllerAs: 'verificationCtrl',
            params : {
               code : null,
               bodyClasses : 'auth'
            }
        })
        .state('app.updateToken', {
            url: '/updateToken',
            templateUrl: templateTokenUpdated,
            controller: 'TokenController',
            controllerAs: 'tokenCtrl',
            params : {
                bodyClasses : 'auth',
                code: {
                    value: 'null',
                    squash: true
                }
            }
        })
        .state('app.cancelToken', {
            url: '/cancelToken',
            templateUrl: templateTokenUpdated,
            controller: 'TokenController',
            controllerAs: 'tokenCtrl',
            params : {
                bodyClasses: 'auth'
            }
        })
        .state('app.forgotten', {
            url: '/forgotten',
            templateUrl: templateForgottenUrl,
            controller: 'RegistrationController',
            controllerAs: 'registrationCtrl',
            params : {
               bodyClasses : 'auth'
            }
        });
}



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/account/account.routes.js
 **/